import classNames from "classnames";
import tabStyles from "components/Tabs/Tabs.module.scss";
import { useState } from "react";
import {
    type Key,
    ToggleButton,
    ToggleButtonGroup,
} from "react-aria-components";

import type { AttributePanelContentProps } from ".";
import { AttributePanelGrid } from "./AttributePanelGrid";

import styles from "./attribute-panel.module.scss";

export const AttributePanelTabbedGrid = ({
    options,
    ...props
}: AttributePanelContentProps) => {
    const tabs: { [id: string]: string } = {};
    for (let opt of options) {
        tabs[opt.attribute.id] = opt.attribute.name;
    }

    const list = Object.entries(tabs);

    const [selected, setSelected] = useState(new Set<Key>([list[0][0]]));

    const currentTabOptions = [...options].filter((opt) =>
        selected.has(String(opt.attribute.id)),
    );

    return (
        <div className={styles.attributePanelTabbedGrid}>
            <ToggleButtonGroup
                selectionMode="single"
                selectedKeys={selected}
                disallowEmptySelection
                onSelectionChange={setSelected}
                className={classNames(tabStyles.buttonBar, styles.tabList)}
            >
                {list.map(([id, name]) => (
                    <ToggleButton
                        id={id}
                        key={id}
                        className={`al-pdp-vc__panel-tab al-pdp-vc__panel-tab--${name} ${tabStyles.button}`}
                    >
                        {name}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
            <AttributePanelGrid {...props} options={currentTabOptions} />
        </div>
    );
};
